import React from 'react'
import { DefaultLayout } from '../../layouts'
import { SimplePageHeader } from '../../components'
import { MainContent, MainContentMobile } from './components'
import atf from '../../database/pages/atf.json'

const Program = () => {
  return (
    <DefaultLayout>
      <SimplePageHeader
        title="Inisiatif"
        description={atf.product}
        largePadding
      />

      {/* MOBILE & TABLET */}
      <div className="lg:hidden">
        <MainContentMobile />
      </div>

      {/* DESKTOP */}
      <MainContent />
    </DefaultLayout>
  )
}

export { Program }
